import React from 'react';
import './SocialLinks.css';

const SocialLinks = ({ title, showIcons = true }) => {
    const links = [
        {
            name: 'Telegram',
            url: 'https://t.me/avisamesibaja',
            icon: 'https://img.icons8.com/color/32/000000/telegram-app.png',
            class: 'telegram'
        },
        {
            name: 'X (Twitter)',
            url: 'https://x.com/avisamesibaja',
            icon: 'https://img.icons8.com/ios-filled/32/000000/twitterx--v2.png',
            class: 'x'
        },
        {
            name: 'Facebook',
            url: 'https://www.facebook.com/avisamesibajacom/',
            icon: 'https://img.icons8.com/color/32/000000/facebook.png',
            class: 'facebook'
        }
    ];

    return (
        <div className="social-links-container">
            {title && <p className="social-links-title">{title}</p>}
            <div className="social-links-grid">
                {links.map((link) => (
                    <a
                        key={link.name}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`social-link-item ${link.class}`}
                    >
                        {showIcons && <img src={link.icon} alt={link.name} />}
                        <span>{link.name}</span>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default SocialLinks;
